import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/type'

import component from 'components/Types/New'

const formName = 'new-type'
const fields = ['name', 'report', 'constrain_options_to_pricelist', 'bin_max', 'bin_uom_id', 'options[].id', 'uoms[].id']

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  onSubmit: (data) => {
    let initialValues = mapStateToProps({}, ownProps).initialValues

    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, initialValues, fields))
  }
})

const mapStateToProps = (state) => ({
  type: state.type,
  options: state.options,
  uoms: state.uoms,
  initialValues: {
    constrain_options_to_pricelist: false,
    options: [{ id: undefined }],
    uoms: [{ id: undefined }]
  }
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Types/containers/NewTypeContainer.js